import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import type { IrescueInfo } from '@/apiFzn/types'
import { getaisDetail } from '@/apiFzn'

/**桥梁数据 */
export const useRescueStore = defineStore('rescue', () => {
  // 状态
  const resumId = ref<number>()
  const showDetail = ref(false)
  const rescumDetail = ref<IrescueInfo>()

  // 方法
  const openRescueDetail = async (id: number) => {
    resumId.value = id
    showDetail.value = true
    await loadaisDetail()
  }

  const closeDetail = () => {
    showDetail.value = false
    resumId.value = undefined
    rescumDetail.value = undefined
  }

  // 私有方法
  const loadaisDetail = async () => {
    if (!resumId.value) return
    try {
      const res = await getaisDetail({ id: resumId.value })
      // rescumDetail.value = res.data
    } catch (error) {
      console.error('获取桥梁详情失败:', error)
    }
  }

  return {
    // 状态
    resumId,
    showDetail,
    rescumDetail,
    // 方法
    openRescueDetail,
    closeDetail,
  }
})
